export default __webpack_public_path__ + "static/media/question-icon.9a5c9987.svg";